import { Container, Row, Col } from 'reactstrap'


export default function ThirdSection() {
    return (
        <section className="screenshots-section position-relative">


            <div style={{ display: 'flex', position: 'absolute', bottom: 0, left: 0, right: 0 }}>
                <div style={{ display: 'flex', position: 'relative'}}>
                    <img src="/images/lp/ball-tennis-1.png" alt="App Screenshot"
                        style={{ height: '80px', position: 'absolute', bottom: 0, left: '140px' }} />
                    <img src="/images/lp/ball-tennis-1.png" alt="App Screenshot"
                        style={{ height: '150px', position: 'absolute', bottom: 0, left: '240px' }} />
                </div>
            </div>

            <Container>
                <Row className="align-items-center g-5 justify-content-center text-center text-lg-start px-3">
                    <Col lg="7" xs="12">
                    <div className="d-flex flex-column gap-3 align-items-center align-items-lg-start">
                        <h2 className="section-title text-white">Aprenda como desafiar seus oponentes</h2>
                        <p className="section-subtitle text-white">
                            e o melhor: criar sua conta é grátis.
                        </p>
                    </div>
                    </Col>
                    <Col lg="5" className="d-flex justify-content-center mx-auto" style={{ maxWidth: '720px' }}>
                        <iframe
                            className="rounded-3 my-4 w-100"
                            style={{ aspectRatio: '16 / 9' }}
                            src="https://www.youtube.com/embed/XY1-hOv8Zi0"
                            title="Conheça o Clube do Tennis"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                        ></iframe>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
